module.exports = __webpack_public_path__ + "assets/img/b1e9bd77baa02672979709b678ea2bde.svg";